import {
  tRelative
} from "./chunk-XNJ3V4UZ.mjs";
import {
  getDateFnsLocale
} from "./chunk-2J3DUGJJ.mjs";

// src/formatDate.ts
import {
  format,
  isToday,
  isYesterday,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInMonths
} from "date-fns";
var fmtLocale = (d, pattern) => format(d, pattern, { locale: getDateFnsLocale() });
function formatDate(date, fmt) {
  const d = typeof date === "string" ? new Date(date) : date;
  switch (fmt) {
    case "TIME_SHORT" /* TIME_SHORT */:
      return fmtLocale(d, "h:mm a");
    case "TIME_LONG" /* TIME_LONG */:
      return fmtLocale(d, "h:mm:ss a");
    case "DATE_SHORT" /* DATE_SHORT */:
      return fmtLocale(d, "MMM d");
    case "DATE_SHORT_WEEKDAY" /* DATE_SHORT_WEEKDAY */:
      return fmtLocale(d, "EEE, MMM d");
    case "DATE_MEDIUM" /* DATE_MEDIUM */:
      return fmtLocale(d, "MMM d, yyyy");
    case "DATE_LONG" /* DATE_LONG */:
      return d.getFullYear() === (/* @__PURE__ */ new Date()).getFullYear() ? fmtLocale(d, "MMMM do") : fmtLocale(d, "MMMM do, yyyy");
    case "DATE_NUMERIC" /* DATE_NUMERIC */:
      return fmtLocale(d, "MM/dd/yyyy");
    case "DATE_PICKER" /* DATE_PICKER */:
      return fmtLocale(d, "dd/MM/yyyy");
    case "DATETIME_MEDIUM" /* DATETIME_MEDIUM */:
      return fmtLocale(d, "MMM d, yyyy h:mm a");
    case "MONTH_YEAR_SHORT" /* MONTH_YEAR_SHORT */:
      return fmtLocale(d, "MMM-yy");
    case "MONTH_YEAR_LONG" /* MONTH_YEAR_LONG */:
      return fmtLocale(d, "MMMM yyyy");
    case "RELATIVE_DAY" /* RELATIVE_DAY */:
      if (isToday(d)) return tRelative("relative.today");
      if (isYesterday(d)) return tRelative("relative.yesterday");
      return fmtLocale(d, "MMMM do");
    case "RELATIVE_SHORT" /* RELATIVE_SHORT */:
      return formatRelativeShort(d);
    case "RELATIVE_LONG" /* RELATIVE_LONG */:
      return formatRelativeLong(d);
    case "RELATIVE_SMART" /* RELATIVE_SMART */:
      return formatRelativeSmart(d);
    default:
      return fmtLocale(d, "MMM d, yyyy h:mm a");
  }
}
function formatMonthYearShort(yyyymm) {
  const match = /^(\d{4})-(\d{2})$/.exec(yyyymm);
  if (!match) return yyyymm;
  const year = Number(match[1]);
  const month = Number(match[2]);
  return formatDate(new Date(year, month - 1, 1), "MONTH_YEAR_SHORT" /* MONTH_YEAR_SHORT */);
}
function formatMonthYearLong(yyyymm) {
  const match = /^(\d{4})-(\d{2})$/.exec(yyyymm);
  if (!match) return yyyymm;
  const year = Number(match[1]);
  const month = Number(match[2]);
  return formatDate(new Date(year, month - 1, 1), "MONTH_YEAR_LONG" /* MONTH_YEAR_LONG */);
}
function formatDateSafe(date, fmt) {
  if (date === null || date === void 0) return void 0;
  const parsed = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(parsed.getTime())) return void 0;
  return formatDate(parsed, fmt);
}
function formatDayTick(yyyymmdd) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(yyyymmdd);
  if (!match) return yyyymmdd;
  const [, year, month, day] = match;
  return formatDate(
    new Date(Number(year), Number(month) - 1, Number(day)),
    "DATE_SHORT" /* DATE_SHORT */
  );
}
function formatRelativeShort(d) {
  const now = /* @__PURE__ */ new Date();
  const mins = differenceInMinutes(now, d);
  if (mins < 1) return tRelative("relative.now");
  if (mins < 60) return tRelative("relative.minutesAgoShort", { count: mins });
  const hrs = differenceInHours(now, d);
  if (hrs < 24) return tRelative("relative.hoursAgoShort", { count: hrs });
  const days = differenceInDays(now, d);
  if (days < 30) return tRelative("relative.daysAgoShort", { count: days });
  const months = differenceInMonths(now, d);
  if (months < 12) return tRelative("relative.monthsAgoShort", { count: months });
  return fmtLocale(d, "MMM yyyy");
}
function formatRelativeLong(d) {
  const now = /* @__PURE__ */ new Date();
  const mins = differenceInMinutes(now, d);
  if (mins < 1) return tRelative("relative.justNow");
  if (mins < 60) return tRelative("relative.minutesAgo", { count: mins });
  const hrs = differenceInHours(now, d);
  if (hrs < 24) return tRelative("relative.hoursAgo", { count: hrs });
  const days = differenceInDays(now, d);
  if (days < 30) return tRelative("relative.daysAgo", { count: days });
  const months = differenceInMonths(now, d);
  if (months < 12) return tRelative("relative.monthsAgo", { count: months });
  return fmtLocale(d, "MMM d, yyyy");
}
function formatRelativeSmart(d) {
  const now = /* @__PURE__ */ new Date();
  const mins = differenceInMinutes(now, d);
  if (mins < 1) return tRelative("relative.justNow");
  if (mins < 60) return tRelative("relative.minutesAgo", { count: mins });
  const hrs = differenceInHours(now, d);
  if (hrs < 24) return tRelative("relative.hoursAgo", { count: hrs });
  if (d.getFullYear() === now.getFullYear()) return fmtLocale(d, "MMM d");
  return fmtLocale(d, "MMM d, yyyy");
}

export {
  formatDate,
  formatMonthYearShort,
  formatMonthYearLong,
  formatDateSafe,
  formatDayTick
};
